import { render, staticRenderFns } from "./ProfileHighlight.vue?vue&type=template&id=5a7dd082"
import script from "./ProfileHighlight.vue?vue&type=script&lang=js"
export * from "./ProfileHighlight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports